import styled from 'styled-components';
import { up } from "styled-breakpoints";


const FeatureList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;

  ${up('sm')} {
    width: 50%;
  }
`;

export default FeatureList;
